module.exports = __webpack_public_path__ + "static/media/weather2.5e23c68e.jpg";